// import {useGetActiveSubstanceDrugs} from '@/modules/drug-catalog/substances/api'
import {mapBasicDataItemsToSelectItems} from '@/modules/basic-data/functions'
import {catalogTypeOptions} from '@/modules/drug-catalog/constants'
import {mapDrugItemsToSelectItems} from '@/modules/drug-catalog/functions'
import {Route} from '@/routes/configuration/products/trade-names'
import {FilterButton} from '@cypro/ui/components/ui/filter-button'
import {ResourcesFiltersContainer} from '@/shared/components/ui/resources-filters-container'
import {useAppForm} from '@cypro/ui/integrations/form'
import {Box, HStack, IconButton} from '@chakra-ui/react'
import {queries} from '@cypro/engine/queries'
import {useQuery} from '@rocicorp/zero/react'
import {useStore} from '@tanstack/react-form'
import {useNavigate} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import {LuCircleX} from 'react-icons/lu'

export function TradeNamesFilters() {
  const {t} = useTranslate('common')
  const search = Route.useSearch()
  const navigate = useNavigate({from: '/configuration/products/trade-names/'})

  const form = useAppForm({
    defaultValues: {
      search: search.filters?.search || '',
      substances: search.filters?.substances || [],
      forms: search.filters?.forms || [],
      types: search.filters?.types || [],
    },
    listeners: {
      onChange({formApi, fieldApi}) {
        // if triggered by the searchbox, prevent the navigation because we want to debouce the "name" filter
        // and we do it directly on the <form.AppField />
        if (fieldApi.name === 'search') return

        const {values} = formApi.state

        navigate({
          to: '/configuration/products/trade-names',
          search: prev => ({
            ...prev,
            filters: {
              search: values.search,
              substances: values.substances,
              forms: values.forms,
              types: values.types,
            },
          }),
        })
      },
    },
  })

  const values = useStore(form.store, state => state.values)
  const hasValues = Boolean(
    values?.search || values?.substances?.length || values?.forms?.length || values?.types?.length
  )

  function onClearFilters() {
    form.setFieldValue('search', '')
    form.setFieldValue('substances', [])
    form.setFieldValue('forms', [])
    form.setFieldValue('types', [])
  }

  const [drugs] = useQuery(queries.products.listTradeNamesDrugs())
  const [medicineForms] = useQuery(queries.products.listTradeNamesMedicineForms())
  const types = catalogTypeOptions.map(item => ({label: t(item), value: item}))

  return (
    <ResourcesFiltersContainer>
      <form.AppForm>
        <HStack>
          <form.AppField name="types">
            {field => (
              <field.Select items={types} label={t('type')} hideLabel multiple>
                <FilterButton isApplied={Boolean(form.state.values.types.length)}>{t('type')}</FilterButton>
              </field.Select>
            )}
          </form.AppField>

          <form.AppField name="forms">
            {field => (
              <field.Select
                items={mapBasicDataItemsToSelectItems(medicineForms, {includeCode: false})}
                label={t('form')}
                hideLabel
                multiple
              >
                <FilterButton isApplied={Boolean(form.state.values.forms.length)}>{t('form')}</FilterButton>
              </field.Select>
            )}
          </form.AppField>

          <form.AppField name="substances">
            {field => (
              <field.Select items={mapDrugItemsToSelectItems(drugs)} label={t('substances')} hideLabel multiple>
                <FilterButton isApplied={Boolean(form.state.values.substances.length)}>{t('substances')}</FilterButton>
              </field.Select>
            )}
          </form.AppField>

          {hasValues && (
            <IconButton variant="ghost" title={t('clear_filters')} onClick={onClearFilters}>
              <LuCircleX />
            </IconButton>
          )}
        </HStack>

        <Box>
          <form.AppField
            name="search"
            listeners={{
              onChange: ({fieldApi}) =>
                navigate({
                  to: '/configuration/products/trade-names',
                  search: prev => ({...prev, filters: {...prev.filters, search: fieldApi.state.value}}),
                }),
              onChangeDebounceMs: 300,
            }}
          >
            {field => <field.Searchbox />}
          </form.AppField>
        </Box>
      </form.AppForm>
    </ResourcesFiltersContainer>
  )
}
